import { render, staticRenderFns } from "./AgreementDetailView.vue?vue&type=template&id=27aacd6e&"
import script from "./AgreementDetailView.vue?vue&type=script&lang=js&"
export * from "./AgreementDetailView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports